import { render, staticRenderFns } from "./ShipperMaterial.vue?vue&type=template&id=1e7247ce&scoped=true&"
import script from "./ShipperMaterial.vue?vue&type=script&lang=js&"
export * from "./ShipperMaterial.vue?vue&type=script&lang=js&"
import style0 from "./ShipperMaterial.vue?vue&type=style&index=0&id=1e7247ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7247ce",
  null
  
)

export default component.exports